
import MailIcon from "@/components/icons/MailIcon.vue";
import { mapGetters } from "vuex";
import ImprovementFormModal from "@/improvementForms/ImprovementFormModal.vue";

export default {
  components: { ImprovementFormModal, MailIcon },
  props: {
    boldText: String,
    smallText: String,
    objectId: {
      type: String,
      required: false,
    },
    type: String,
  },
  computed: {
    ...mapGetters("accounts", ["user"]),
  },
};
